import { ChartType } from "../../models/chart_model";

export const H_CHART_TYPES = [
    { value: ChartType.Bar, label: "Standard Bar", stackId: undefined},
    // { value: ChartType.Bar, label: "Stacked Bar", stackId: "a" },
    { value: ChartType.Line, label: "Line" },
  ];

export const H_AREA_CHART_TYPES = 
    { value: ChartType.Area, label: "Area", stackId: "stacked"};

    
  // NEW FUNCTION: Use this to format dates for API calls
  export function formatDateForAPI(date: Date): string {
    // Format date in YYYY-MM-DD format preserving local date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }